module.exports = __webpack_public_path__ + "static/media/aa.df4321b9.svg";